exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qmodii .v-responsive{position:relative;overflow:hidden;flex:1 0 auto;display:flex}.qmodii .v-responsive__content{flex:1 0 0px}.qmodii .v-responsive__sizer{transition:padding-bottom .2s cubic-bezier(.25,.8,.5,1);flex:0 0 0px}", ""]);

// exports
